import React from "react";

import ReactQuill from "react-quill";

import "react-quill/dist/quill.snow.css";

interface DataProps {
  value?: string;
  onChange?: any;
  placeholder?: string;
  hideToolbar?: boolean;
  readOnly?: boolean;
  hideEditor?: boolean;
}

export const Editor: React.FC<DataProps> = ({
  value,
  onChange,
  placeholder,
  hideToolbar,
  readOnly,
  hideEditor,
}): JSX.Element => {
  const modules = {
    toolbar: hideToolbar
      ? false
      : [
          ["bold", "italic", "underline", "strike"],
          ["link"],
          [{ header: 1 }, { header: 2 }],
          [{ list: "ordered" }, { list: "bullet" }, { list: "check" }],
          [{ indent: "-1" }, { indent: "+1" }],
          [{ header: [1, 2, 3, 4, 5, 6, false] }],
          [{ color: [] }],
          [{ align: [] }],
          ["clean"],
        ],
  };

  const formats = [
    "header",
    "bold",
    "italic",
    "underline",
    "strike",
    "list",
    "bullet",
    "indent",
    "link",
    "image",
    "color",
  ];

  return (
    <ReactQuill
      value={value || ""}
      onChange={onChange}
      readOnly={readOnly}
      modules={modules}
      className={`editor ${hideEditor ? "hide" : ""}`}
      formats={formats}
      placeholder={placeholder || "Enter value"}
    />
  );
};
